import { ArrowRight } from '@dreamstack/icons/src/icon-components/ArrowRight'
import { CheckOutlined } from '@dreamstack/icons/src/icon-components/CheckOutlined'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { default as React } from 'react'
import { SimpleMuiButton } from '../layout/SimpleMuiButton'
import { SimpleNotificationPopover } from './SimpleNotificationPopover'

export type NotificationPopoverType = 'cta' | 'success'

export const NotificationPopover: FunctionComponent<
  React.PropsWithChildren<{
    type: NotificationPopoverType
    title: string
    text?: string
    buttonText: string
    buttonHref: string
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    setPopperElement: React.Dispatch<(prevState: undefined) => undefined>
    styles: any
    attributes: any
  }>
> = ({
  type,
  title,
  text,
  buttonHref,
  buttonText,
  open,
  setOpen,
  setPopperElement,
  styles,
  attributes,
}) => {
  const isCta = type === 'cta'
  const isSucess = type === 'success'

  return (
    <SimpleNotificationPopover
      open={open}
      setPopperElement={setPopperElement}
      styles={styles}
      attributes={attributes}
      setOpen={setOpen}
    >
      {isSucess && (
        <div className="mr-px-16 -ml-px-4 mb-px-8 md:ml-0 md:mb-0">
          <CheckOutlined className="w-px-32 h-px-32 text-accentroLightGreen-full" />
        </div>
      )}
      <div>
        <div className="text-px-16 leading-px-24 font-semibold">{title}</div>
        {text && <div className="text-px-16 leading-px-24 mt-px-8">{text}</div>}
        <div className="text-px-16 leading-px-24 mt-px-8">
          <Link href={buttonHref}>
            {isCta ? (
              <SimpleMuiButton
                variant={'outlined'}
                color={'secondary'}
                endIcon={isSucess && <ArrowRight className="h-px-32 w-px-32" />}
              >
                {buttonText}
              </SimpleMuiButton>
            ) : (
              <SimpleMuiButton
                variant="text"
                color="primary"
                endIcon={<ArrowRight className="h-px-32 w-px-32" />}
              >
                <span className="text-left text-px-16 leading-px-24">
                  {buttonText}
                </span>
              </SimpleMuiButton>
            )}
          </Link>
        </div>
      </div>
    </SimpleNotificationPopover>
  )
}
